import type {RootState} from "../store";

function selectChapterCompletionRewardStatus(
	state: RootState,
	chapterKey: string
) {
	return (
		state.ui.chapterCompletionReward.byKey[chapterKey]?.status ?? "never_shown"
	);
}

export default selectChapterCompletionRewardStatus;
